// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ImageUtils = require("./imageUtils");
let Stdlib_Nullable = require("@rescript/runtime/lib/js/Stdlib_Nullable.js");

function resize(maxWidth, maxHeight, file) {
  return ImageUtils.resize(file, Stdlib_Nullable.fromOption(maxWidth), Stdlib_Nullable.fromOption(maxHeight));
}

function _getCroppedImage(prim0, prim1) {
  return ImageUtils.getCroppedImg(prim0, prim1);
}

let getCroppedImage = _getCroppedImage;

exports.getCroppedImage = getCroppedImage;
exports.resize = resize;
/* ./imageUtils Not a pure module */
